import { QueryObserver, QueryObserverOptions } from '@tanstack/query-core';

import { fetchWorkspacesListing } from '../../../../predict/src/core/api/workspaces';
import { queryClient } from '../../../core/queryClient';

/**
 * workspacesListingQuery
 */
export type FetchWorkspacesListingResult = Awaited<ReturnType<typeof fetchWorkspacesListing>>;
type WorkspacesListingQueryOptions = Omit<QueryObserverOptions<FetchWorkspacesListingResult>, 'queryKey' | 'queryFn'>;

export const workspacesListingQueryKey = () => ['workspaces-listing'];

export const clearWorkspacesListingQueryCache = (): void => {
  queryClient.invalidateQueries({ queryKey: workspacesListingQueryKey() });
};

export const workspacesListingQuery = (
  options?: WorkspacesListingQueryOptions
): QueryObserver<FetchWorkspacesListingResult> =>
  new QueryObserver<FetchWorkspacesListingResult>(queryClient, {
    queryKey: workspacesListingQueryKey(),
    queryFn: () => fetchWorkspacesListing(),
    ...options
  });
